
import store from 'stores/store'
import resizeStore from 'stores/resizeStore'

const globalStore = Object.assign({}, store, resizeStore)
export default globalStore
